module.exports = __webpack_public_path__ + "static/img/footer.fb358df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer.jpg
// module id = v5Mo
// module chunks = 1